import * as Sentry from "@sentry/react";
import { getEnv } from "@/config/env";

/**
 * Initialize Sentry for frontend error tracking.
 * Only enabled in production when VITE_SENTRY_DSN is set.
 */
export function initSentry(): void {
  const dsn = getEnv("VITE_SENTRY_DSN");

  if (!dsn || import.meta.env.DEV) {
    return;
  }

  const release = getEnv("VITE_SENTRY_RELEASE");

  Sentry.init({
    dsn,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    environment: getEnv("VITE_SENTRY_ENVIRONMENT") || "production",
    ...(release ? { release } : {}),
  });
}
